import React from "react";
import { Box } from "@mui/material";
import { SideNav } from "../../components/dashboard/layout/side-nav";
import GlobalStyles from "@mui/material/GlobalStyles";
import Container from "@mui/material/Container";
import { MainNav } from "../../components/dashboard/layout/main-nav";
import AdminSubNav from "../../components/dashboard/layout/admin-sub-nav";
import BulkJobBanner from "../../components/dashboard/layout/BulkJobBanner";
import PricingJobBanner from "../../components/dashboard/layout/PricingJobBanner";
import SellviaCleanupBanner from "../../components/dashboard/layout/SellviaCleanupBanner";
import SellviaActivityBanner from "../../components/dashboard/layout/SellviaActivityBanner";

const AdminLayout = ({ children }) => {
  return (
    <div>
      <GlobalStyles
        styles={{
          body: {
            "--MainNav-height": "64px",
            "--MainNav-zIndex": 1000,
            "--SideNav-width": "250px",
            "--SideNav-zIndex": 1100,
            "--MobileNav-width": "320px",
            "--MobileNav-zIndex": 1100,
          },
        }}
      />
      <Box
        sx={{
          bgcolor: "var(--mui-palette-background-default)",
          display: "flex",
          flexDirection: "column",
          position: "relative",
          minHeight: "100%",
        }}
      >
        {/* SideNav is full-height, fixed to the left edge from the very top
            of the page. MainNav sits in the content column beside it, so
            its left edge touches the sidebar's right border instead of
            spanning the full page width above it. */}
        <Box sx={{ display: "flex", flex: "1 1 auto" }}>
          <SideNav />
          <Box
            sx={{
              display: "flex",
              flex: "1 1 auto",
              flexDirection: "column",
              pl: { lg: "var(--SideNav-width)" },
              // Room for the docked AI chat panel (set by ChatBot.jsx, 0 when it is not docked).
              pr: { md: "var(--ChatDock-width, 0px)" },
              transition: "padding-right 0.2s ease",
              // Responsive fix: a flex item defaults to min-width:auto, so this
              // column refused to get narrower than its widest content — with
              // the sidebar open, pages spilled off the right edge, and on
              // phones the browser zoomed the whole page out to fit that
              // extra width. minWidth:0 lets it shrink to the space actually
              // left beside the sidebar; overflowX:clip stops any stray wide
              // element from widening the page (wide tables scroll inside
              // their own containers instead).
              minWidth: 0,
              width: "100%",
              overflowX: "clip",
            }}
          >
            <MainNav />
            <BulkJobBanner />
            <PricingJobBanner />
            <SellviaCleanupBanner />
            <SellviaActivityBanner />
            <AdminSubNav /> {/* AdminSubNav only shows for Master Settings children */}
            <main style={{ minWidth: 0 }}>
              {/* maxWidth={false} — a fixed "xl" cap left a big empty gap,
                  symmetric on both sides, once the sidebar collapses and
                  frees up more width than the cap allows for; this way the
                  content always fills whatever space the sidebar leaves. */}
              <Container maxWidth={false} sx={{ py: { xs: "24px", sm: "40px", md: "64px" }, px: { xs: 1.5, sm: 3 } }}>
                {children}
              </Container>
            </main>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default AdminLayout;
